import { module as BaseModule } from 'modujs';
import Plyr from 'plyr';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		let item = this.el;
		let vid = item.querySelector('.video-player');

		if (vid) {
			// Obtener los atributos de los elementos HTML
			const image = item.getAttribute('data-plyr-poster');
			const hideControls = item.getAttribute('data-plyr-controls') === 'false';
			const autoplay = item.getAttribute('data-plyr-autoplay') === 'true';
			const loop = item.getAttribute('data-plyr-loop') === 'true';

			// Configuración de los controles en función del valor de hideControls
			let plyControls = ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'fullscreen'];

			if (hideControls) {
				plyControls = [];
			}

			// Inicialización del reproductor Plyr
			let player = new Plyr(vid, {
				autoplay: true,
				muted: autoplay, // Silenciar el video si autoplay está activo, para que funcione en todos los navegadores
				controls: plyControls,
				loop: { active: loop }, // Nota que loop debe estar dentro de un objeto
				poster: image,
			});

			if (autoplay) {
				player.play();
			}

			// Si se especifica una imagen de póster, aplícala después de la inicialización
			if (image) {
				setTimeout(() => {
					player.poster = image;
				}, 500);
			}
		} else {
			console.log('Elemento video-player no encontrado.');
		}
	}
}
